import { EntityWithStatusService } from './EntityWithStatusService';
import { IRiskMitigationAction} from '../types';

export class RiskMitigationActionService<T extends IRiskMitigationAction> extends EntityWithStatusService<T> {
    protected childrenEntities = ['Contributors($expand=ContributorUser)'];

    constructor(url: string) {
        super(url);
    }

    public readMitigationActionsForRisk(riskId: number): Promise<T[]> {
        return this.readAll(
            `?$filter=RiskID eq ${riskId}`
            + `&$expand=OwnerUser($select=Title),EntityStatus($select=Title),Contributors`
            + `&$orderby=RiskMitigationActionCode,Title`
        );
    }
}